<template>
    <div>
        <button class="button button--ghost" v-on:click='back()' type="button">
            <i class="icon-chevron-left button__icon button__icon--left"></i> <T>Vorige stap</T>
        </button>
    </div>
</template>

<script>
    export default {
        name: 'BackButton',
        props: {
            noUploadStep: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            back() {
                this.$StepHelper.back(this.noUploadStep);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/components/BackButton.vue